import React from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import PackActions from '../actions/PackActions';
import AuthStore from '../stores/AuthStore';
import StateStore from '../stores/StateStore';
import Popup from 'react-popup';

class DoneComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      order: StateStore.getOrder(),
      config: AuthStore.getConfig(),
      uid: AuthStore.getUser().id,
      pakowalnia_id: AuthStore.getPakowalnia(),
      done: StateStore.getDone()
    }
    this.printLabelAgain = this.printLabelAgain.bind(this)
    this.printInvoice = this.printInvoice.bind(this)
    this.confirmDone = this.confirmDone.bind(this)
  }

  confirmDone() {
    if (this.state.order.invoice_option && !this.state.config.print_invoice_automatically && !this.state.config.dont_print_invoice) {
      Popup.create({
        content: intl.get('Do tego zamówienia wymagana jest faktura, na pewno chcesz kontynuować?'),
        buttons: {
          right: [{
            text: intl.get('Tak'),
            key: 'enter',
            action: function () {
              Popup.close()
              PackActions.confirmDone()
            }
          },
          {
            text: intl.get('Anuluj'),
            className: 'cancel-button',
            action: function () {
              Popup.close()
            }
          }]
        }
      })
    } else {
      PackActions.confirmDone()
    }
  }

  printLabelAgain() {
    let self = this
    Popup.create({
      content: intl.get('Na pewno chcesz drukować etykietę jeszcze raz?'),
      buttons: {
        right: [{
          text: 'Tak',
          key: 'enter',
          action: function () {
            Popup.close()
            PackActions.printLabelAgain(self.state.order.id, self.state.pakowalnia_id)
          }
        },
        {
          text: 'Anuluj',
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  printInvoice() {
    let self = this
    Popup.create({
      content: intl.get('Na pewno chcesz wydrukować fakturę?'),
      buttons: {
        right: [{
          text: 'Tak',
          key: 'enter',
          action: function () {
            Popup.close()
            PackActions.printInvoice(self.state.order.id, self.state.uid, self.state.pakowalnia_id)
          }
        },
        {
          text: 'Anuluj',
          className: 'cancel-button',
          action: function () {
            Popup.close()
          }
        }]
      }
    })
  }

  render() {
    let order = this.state.order
    let done = this.state.done
    let config = this.state.config
    let odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')
    return (
      <div>
        <div className={'ramka done'+(order.invoice_option && config.red_frame ? ' special' : '')}>
          <h3>{intl.get('Zapisano!')}</h3>
          <div className="center">{intl.get('Wszystkie dane zostały poprawnie zapisane w systemie.')}</div>
          <div className="summary">
            <h4>{intl.get('Zamówienie')} {order.name}</h4>
            <label>{intl.get('Sprzedawca')}:</label>
            <span>{order.shop_id}</span><br/>
            <label>{intl.get('Data zamówienia')}:</label>
            <span>{order.date_order}</span><br/>
            <label>{intl.get('Kwota zamówienia')}:</label>
            <span>{order.amount_total}</span><br/>
            <label>{intl.get('Adres dostawy')}:</label>
            <span>{order.delivery_name}</span><br/>
            <label></label>
            <span>{order.delivery_street}</span><br/>
            <label></label>
            <span>{order.delivery_zip} {order.delivery_city}</span><br/>
            <label>{intl.get('Metoda dostawy')}:</label>
            <span>{order.carrier_name}</span><br/>
            <label></label>
            <span className="shippinglogo">
              <img src={`${odoo}/web/delivery_carrier_image?carrier_id=${order.carrier_id || ''}`} /><br/>
            </span>
            {order.allegro_account &&
              <div>
                <label>{intl.get('Login Allegro sprzedawcy')}:</label>
                <span>{order.allegro_account}</span><br/>
              </div>
            }
            {order.allegro_client_login &&
              <div>
                <label>{intl.get('Login Allegro klienta')}:</label>
                <span>{order.allegro_client_login}</span><br/>
              </div>
            }
            <label>{intl.get('Uwagi klienta')}:</label>
            <span style={{'fontStyle': 'italic'}}>{order.note}</span><br/>
            <label>{intl.get('Potwierdzenie')}:</label>
            <span>{order.invoice_option ? <strong style={{'color': '#f00'}}>{intl.get('FAKTURA')}</strong> : 'paragon'}</span>
            {(done && done !== true) &&
              <div>
                <label>{intl.get('Utworzono fakturę')}:</label>
                <span><strong>{done}</strong></span><br/>
              </div>
            }
            <div className="printInvoice">
              <button onClick={this.printInvoice} className={order.invoice_option?'highlighted':''}>{intl.get('Drukuj fakturę')}</button>
            </div>
          </div>
          <br/>
          <button onClick={this.confirmDone}>{intl.get('Kontynuuj')}</button><br/>
          {intl.get('lub')} <button className="smallButton" onClick={this.printLabelAgain}>{intl.get('Ponownie drukuj etykietę')}</button>
        </div>
      </div>
    )
  }
}

export default withRouter(DoneComponent);



// WEBPACK FOOTER //
// ./src/components/Done.js